import api from '../utils/api'

const base = (businessId) => `/api/business_B/${businessId}/reviews`

/** 後台評價列表 */
export const listBusinessReviews = (businessId, params = {}) =>
  api({ url: base(businessId), method: 'get', params })

/** 新增或編輯店家回覆 */
export const replyBusinessReview = (businessId, reviewId, content) =>
  api({
    url: `${base(businessId)}/${reviewId}/reply`,
    method: 'put',
    data: { content }
  })

/** 刪除店家回覆 */
export const deleteBusinessReviewReply = (businessId, reviewId) =>
  api({ url: `${base(businessId)}/${reviewId}/reply`, method: 'delete' })
